export const s3UrlExample = {
    url: "https://s3-demo.warren.io/",
};
